import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { PUT } from '../../../../config/permissions';
import { generateEditBusMaintenaceStayPath } from '../../../../config/endpoints';

const EditBusMaintenanceStayButton = ({
  handleEdit,
  busMaintenanceStay,
  index,
}) => {

  const isMarkedForDelete = busMaintenanceStay.markedForDelete;

  return (
    <Button
      color="info"
      outline
      className="mr-3"
      onClick={() => handleEdit(busMaintenanceStay, index)}
      disabled={isMarkedForDelete}
      title="Editar"
    >
      <i className="fa fa-pencil" />
    </Button>
  );
};

EditBusMaintenanceStayButton.propTypes = {
  busMaintenanceStay: PropTypes.shape({
    markedForDelete: PropTypes.bool,
  }).isRequired,
  handleEdit: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default withEndpointAuthorization({
  url: generateEditBusMaintenaceStayPath(0),
  permissionType: PUT,
})(EditBusMaintenanceStayButton);
